<template>
  <!--
    CredibilitySection — conveys ThinkSpatial's experience, clients, and
    partners on the Home_Page (Requirement 4.4). Copy and imagery come from the
    structured Home content module.
  -->
  <section class="credibility" aria-labelledby="credibility-heading">
    <v-container>
      <ScrollReveal tag="div" class="credibility__head">
        <h2 id="credibility-heading" class="credibility__heading">
          {{ credibility.heading }}
        </h2>
        <p v-if="credibility.intro" class="credibility__intro">
          {{ credibility.intro }}
        </p>
      </ScrollReveal>

      <!--
        Concrete credentials (accreditations, standards, capacity) shown above
        the project highlights, since these are the strongest proof points for
        infrastructure and construction clients.
      -->
      <div
        v-if="credibility.credentials"
        class="credibility__credentials"
      >
        <ScrollReveal
          v-for="(credential, index) in credibility.credentials"
          :key="credential.title"
          tag="div"
          :delay="index * 60"
        >
          <div class="credibility__credential">
            <h3 class="credibility__credential-title">{{ credential.title }}</h3>
            <p class="credibility__credential-body">{{ credential.body }}</p>
          </div>
        </ScrollReveal>
      </div>

      <v-row class="credibility__grid" align="stretch">
        <v-col
          v-for="(item, index) in credibility.highlights"
          :key="item.title"
          cols="12"
          md="6"
        >
          <ScrollReveal tag="div" :delay="index * 80">
            <v-card class="credibility__card" height="100%">
              <v-img
                v-if="item.image"
                :src="item.image.src"
                :alt="item.image.alt"
                height="240"
                cover
                loading="lazy"
              />
              <v-card-item>
                <v-card-title class="credibility__card-title">
                  {{ item.title }}
                </v-card-title>
              </v-card-item>
              <v-card-text v-if="item.body" class="credibility__card-body">
                {{ item.body }}
              </v-card-text>
            </v-card>
          </ScrollReveal>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
// CredibilitySection — Home_Page experience/clients/partners (Requirement 4.4).
import ScrollReveal from 'components/ScrollReveal.vue'
import home from 'src/content/home'

export default {
  name: 'CredibilitySection',
  components: { ScrollReveal },
  data () {
    return {
      credibility: home.credibility
    }
  }
}
</script>

<style scoped>
.credibility {
  padding: 72px 0;
  background: #fff;
}

.credibility__head {
  text-align: center;
  max-width: 760px;
  margin: 0 auto 40px;
}

.credibility__heading {
  font-size: clamp(1.8rem, 4vw, 2.6rem);
  font-weight: 800;
  margin-bottom: 12px;
  color: #41281b;
}

.credibility__intro {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #4a4a4a;
}

.credibility__credentials {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 48px;
}

.credibility__credential {
  height: 100%;
  padding: 20px;
  background: #f7f5f4;
  border-left: 4px solid #e7511e;
  border-radius: 10px;
}

.credibility__credential-title {
  font-size: 1.02rem;
  font-weight: 800;
  color: #41281b;
  margin-bottom: 6px;
  line-height: 1.35;
}

.credibility__credential-body {
  font-size: 0.95rem;
  color: #4a4a4a;
  line-height: 1.55;
}

.credibility__card {
  overflow: hidden;
}

.credibility__card-title {
  font-weight: 700;
  color: #41281b;
  white-space: normal;
}

.credibility__card-body {
  color: #4a4a4a;
  line-height: 1.7;
}
</style>
